import { createContext, useContext } from 'react';

export type CollapseControlContextValue = {
    forcedOpen: boolean | undefined;
    forceVersion: number;
    setAll: (open: boolean) => void;
};

export const CollapseControlContext = createContext<CollapseControlContextValue | null>(null);

export const useCollapseControls = () => useContext(CollapseControlContext);
